import Card from "react-bootstrap/Card";

const DashboardCard = (props) => {
  
  return (
    <Card className="cardBox">
      <div className="cardTopImage">
        <img
          src={props.image}
          alt=""
        ></img>
      </div>
      <div className="cardMidText generalFont">{props.message}</div>
      <div className="cardValueStyle generalFont">{props.value}</div>
    </Card>
  );
};

export default DashboardCard;
